import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { Constants } from "@config/constants";
import { AuthService } from "@services/auth.service";

export const beforeLoginAuthGuard: CanActivateChildFn = (route, state) => {
  const _router = inject(Router);
  const bypassGuard =
    _router.getCurrentNavigation()?.extras?.state?.["bypassGuard"] ?? false;
  const uri = _router.getCurrentNavigation()?.extras?.state?.["uri"];
  const authService = new AuthService();

  const token = authService.getAuthTokenFromLocalStorage();
  if (token) {
    authService.navigateAfterLogin(
      bypassGuard && uri === Constants.DEFAULT_ROUTE_AFTER_LOGIN
        ? "customers"
        : Constants.DEFAULT_ROUTE_AFTER_LOGIN
    );
  }

  return true;
};

export const afterLoginAuthGuard: CanActivateChildFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const token = authService.getAuthTokenFromLocalStorage();
  if (!token) {
    return router.createUrlTree(["/login"]);
  }

  return true;
};

export const adminAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const token = authService.getAuthTokenFromLocalStorage();
  if (!token) {
    return router.createUrlTree(["/login"]);
  }

  const user = authService.getUserDetails();
  if (user && user.CustomerId) {
    return router.createUrlTree(["/requests"]);
  }

  return true;
};
